<template>
  <div>
    <page-header :title="$t('scope.text_294')" />
    <page-body>
      <invoice-info-manager-list :id="listId" :getParams="getParams" />
    </page-body>
  </div>
</template>

<script>
import InvoiceInfoManagerList from './components/List'

export default {
  name: 'InvoiceInfoManagerIndex',
  components: {
    InvoiceInfoManagerList,
  },
  data () {
    return {
      listId: 'invoiceInfoManagerList',
      getParams: {
        details: true,
      },
    }
  },
}
</script>
